import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
export var SET_CSRF_TOKEN = 'form/SET_CSRF_TOKEN';
export var types = {
  SET_CSRF_TOKEN: SET_CSRF_TOKEN
};
export var initialState = {
  enabled: false
};
export function csrfReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_CSRF_TOKEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        token: action.token,
        enabled: true
      });
    default:
      return state;
  }
}